import { useEffect } from 'react';
import { ExcelReportInfoBM } from '../types/BusinessModel/ExcelReportInfoBM';
import * as FileSaver from 'file-saver';
import { useVesselStore } from '../context/VesselContext';
import useApi from './useApi';
import useApiEndpoints from '../context/useApiEndpoints';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import { useToast } from '../app/useToast';
import { prettifyDateTime } from 'odfjell-date-time-utils/dateTimeFormatter';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { selectedVessel, setLoadingExcelFile } = useVesselStore();
    const { state, postApiData } = useApi();
    const { toastError } = useToast();

    useEffect(() => {
        processApiEndpointError(state);
        setLoadingExcelFile(false);
    }, [state]);

    const createExcel = async (excelRepInfo: ExcelReportInfoBM | null) => {
        if (excelRepInfo) {
            const result = await postApiData({
                endpoint: apiEndpoints['createExcelReport'].url,
                queryParam: buildQueryParams({
                    imoNumber: selectedVessel?.imoNumber,
                }),
                data: excelRepInfo,
                config: {
                    headers: { 'Content-Type': 'blob' },
                    responseType: 'arraybuffer',
                },
                shouldReturnError: true,
            });

            const excelFilename = getExcelFilename(excelRepInfo);
            if (result != null && (result as ArrayBuffer).byteLength > 0) {
                saveExcel(excelFilename, result);
            } else {
                // Check if there was an API error by examining the state
                if (state.status === 'error') {
                    console.error('Excel generation failed:', state.error);
                    toastError('Failed to generate report.');
                } else {
                    toastError('No data found when attempting to generate report.');
                }
            }
        }
    };

    const getExcelFilename = (excelRepInfo: ExcelReportInfoBM): string => {
        return excelRepInfo.filename + ' ' + prettifyDateTime(new Date()) + '.xlsx';
    };

    const saveExcel = (filename: string, data: any) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, filename);
    };

    return {
        createExcel,
    };
};
